import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http, RequestOptions, XHRBackend } from '@angular/http';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { MyDatePickerModule } from 'mydatepicker';
import { DataTableModule } from 'angular2-datatable';
import { SharedModule } from './shared/shared.module';
import { HashLocationStrategy, LocationStrategy} from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { D3Service } from 'd3-ng2-service';
import { LOCALE_ID } from '@angular/core';
import { ChartsModule } from 'ng2-charts';
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';
import { LaddaModule } from 'angular2-ladda';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TableModule } from 'primeng/table';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatButtonModule, MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
// Routing NgModule
import { AppRoutingModule } from './app-routing.module';
//import {AutocompleteLibModule} from 'angular-ng-autocomplete';

// Services
import { ExtendedHttpService } from './services/extendedhttp.service';
import { ModalService } from './services/modal.service';
import { AdminGuard, DriverGuard, RecordKeeperGuard, ExternalApiUserGuard, ProviderGuard } from './guards/index';
import { AuthenticationService, AdminUserService, ErrorService, ResetPasswordService,
  TimezoneService, DriverService, CarrierService, ServerService,
  LocationService, WorkDiaryService, VersionService, ExternalAccountService, ProviderService } from './services/index';
import { DialogService } from './services/dialog.service';

// Directives
import { EqualValidator } from './directives/equal-validator.directive';  // import validator

// Layouts
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AppComponent } from './app.component';
import { LoginComponent } from './account/login/login.component';
import { TokenLoginComponent } from './account/token-login/token-login.component';
import { SignUpComponent } from './account/signup/signup.component';
import { ResetPasswordComponent } from './account/resetpassword/resetpassword.component';
import { ConfirmEmailComponent } from './account/confirmemail/confirmemail.component';
import { PageNotFoundComponent } from './shared/not-found/not-found.component';
import { DriverLayoutComponent } from './layouts/driver-layout/driver-layout.component';
// import { ToggleDirective } from './directives/toggle.directive';
// import { DropdownDirective } from './directives/dropdown.directive';
import { DriverComponent } from './driver/driver.component';
import { DatabaseComponent } from './admin/driver/database/database.component';
import { RecordkeeperComponent } from './recordkeeper/recordkeeper.component';
import { RecordkeeperLayoutComponent } from './layouts/recordkeeper-layout/recordkeeper-layout.component';
import { HelpComponent } from './system/help/help.component';
import { AboutComponent } from './system/about/about.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    TokenLoginComponent,
    SignUpComponent,
    DriverLayoutComponent,
    ResetPasswordComponent,
    ConfirmEmailComponent,
    AdminLayoutComponent,
    PageNotFoundComponent,
    EqualValidator,
    // ToggleDirective,
    // DropdownDirective,
    DriverComponent,
    RecordkeeperComponent,
    RecordkeeperLayoutComponent,
    HelpComponent,
    AboutComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    // ModalModule,
    SimpleNotificationsModule.forRoot(),
    SimpleNotificationsModule,
    MyDatePickerModule,
    DataTableModule,
    SharedModule,
    ChartsModule,
    Ng2AutoCompleteModule,
    LaddaModule,
    NgxSpinnerModule,
    TableModule,
    MatButtonModule,
    MatDialogModule
    //AutocompleteLibModule
  ],
  providers: [
    { provide: Http, useClass: ExtendedHttpService},
    { provide: LocationStrategy, useClass: HashLocationStrategy},
    { provide: LOCALE_ID, useValue: 'en-US' },
    { provide: HttpClient, useClass: ExtendedHttpService},
    { provide: MatDialogRef, useValue: {}},
    { provide: MAT_DIALOG_DATA, useValue: []},
    AdminGuard,
    DriverGuard,
    RecordKeeperGuard,
    ModalService,
    AuthenticationService,
    AdminUserService,
    SignUpComponent,
    ResetPasswordService,
    ErrorService,
    TimezoneService,
    DriverService,
    CarrierService,
    ServerService,
    D3Service,
    LocationService,
    DatabaseComponent,
    WorkDiaryService,
    VersionService,
    ExternalAccountService,
    ExternalApiUserGuard,
    ProviderService,
    ProviderGuard
  ],
  bootstrap: [AppComponent],
  exports: [],
  entryComponents: [ HelpComponent, AboutComponent ]
})
export class AppModule { }
